/**
 * Per-account permissible font families from yb360 core3 (wpcauth), not the Larry API base URL.
 */

import { getAuthApiUrl } from '@/config/config'
import { getWpcauthForExternalApi } from '@/api/services/auth.service'
import type { FontFamiliesResponse } from '@/api/types/font-family'
import { logger } from '@/utils/logger'

const FONT_FAMILIES_PATH = '/core3/usedFontFamilies/all'

export async function getFontFamiliesAll(spreadId?: string): Promise<FontFamiliesResponse> {
  const base = getAuthApiUrl().replace(/\/$/, '')
  const wpcauth = getWpcauthForExternalApi()

  if (!wpcauth) {
    throw new Error('Font families require wpcauth session; please log in.')
  }

  const qs = spreadId ? `?spreadId=${encodeURIComponent(spreadId)}` : ''
  const url = `${base}${FONT_FAMILIES_PATH}${qs}`

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      wpcauth,
    },
  })

  if (!response.ok) {
    const text = await response.text().catch(() => '')

    throw new Error(
      `Font families request failed: ${response.status} ${response.statusText}${text ? ` — ${text}` : ''}`
    )
  }

  const data = (await response.json()) as FontFamiliesResponse

  if (!data?.result || !Array.isArray(data.payload)) {
    logger.warn('Font family API returned unexpected shape', { data })
    throw new Error('Font family API returned invalid response')
  }

  return data
}
